export default "__VITE_ASSET__de667891__"